import { gql } from '@apollo/client';

export const VERSIONS = gql`
  query versions {
    versions {
      easter_egg
      backend
    }
  }
`;
